<kpd-side-panel
  [facade]="permissionFacade"
  [entityName]="'Permission' | translate"
  class="roles__sidepanel"
  (itemChanged)="onItemChange($event)"
>
  <ng-template kpdTemplate="actionbar" let-selection let-loading="loading" let-deleted="deleted">
    <ng-container *ngIf="selection.length !== 0 && !deleted">
      <kpd-action-consult-overview (action)="onView(selection[0])" [disable]="loading"></kpd-action-consult-overview>
    </ng-container>
  </ng-template>

  <ng-template kpdTemplate="singleItem" let-item>
    <h3 translate>General</h3>
    <div class="flex-row flex-wrap">
      <div class="flex-column">
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>Application</label>
          <label class="value">{{ item.application | kpdDefault }}</label>
        </div>
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>Name</label>
          <label class="value">{{ item.name | kpdDefault }}</label>
        </div>
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>Description</label>
          <label class="value">{{ item.description | kpdDefault }}</label>
        </div>
      </div>
    </div>
    <div class="flex-row flex-center flex-align-items-center w-100pct" style="height: 200px" *ngIf="loading.length > 0">
      <kpd-spinner></kpd-spinner>
    </div>
  </ng-template>

  <ng-template kpdTemplate="multiItem" let-item>
    <div class="card-small">
      <label class="card__header">
        <span class="card__multival flex-row">
          <b>{{ item.application }}</b
          >&nbsp;-&nbsp;{{ item.name }}
        </span>
      </label>
    </div>
  </ng-template>
  <ng-template kpdTemplate="tiles" let-item>
    <div>
      <kpd-tile
        icon="unlock"
        [value]="permissionSetCount"
        [title]="'Permissionsets' | translate"
        (click)="navigateToPermissionsets(item.id)"
      ></kpd-tile>
    </div>
    <kpd-tile
      icon="users"
      [title]="'Roles' | translate"
      [value]="roleCount"
      (click)="navigateToRoles(item.id)"
    ></kpd-tile>
    <kpd-tile
      icon="user"
      [title]="'Users' | translate"
      [value]="userCount"
      (click)="navigateToUsers(item.id)"
    ></kpd-tile>
  </ng-template>
  <kpd-side-panel> </kpd-side-panel
></kpd-side-panel>
